import { t as tr } from '../i18n.js'
import { NavLink } from 'react-router'

export function PortfolioTabs({ portfolioId, active }: { portfolioId: string; active: 'overview' | 'board' | 'list' | 'gantt' }) {
  return (
    <nav className="row tabs">
      <NavLink to={`/portfolios/${portfolioId}`} end className={active === 'overview' ? 'active' : ''} data-tip={tr("Dashboard, projects, members, settings")}>{tr("Overview")}</NavLink>
      <NavLink to={`/portfolios/${portfolioId}/board`} className={active === 'board' ? 'active' : ''} data-tip={tr("Kanban board across every project in the portfolio")}>{tr("Board")}</NavLink>
      <NavLink to={`/portfolios/${portfolioId}/list`} className={active === 'list' ? 'active' : ''} data-tip={tr("Sortable table of tasks across every project in the portfolio")}>{tr("List")}</NavLink>
      <NavLink to={`/portfolios/${portfolioId}/gantt`} className={active === 'gantt' ? 'active' : ''} data-tip={tr("Timeline across projects: cross-project links, critical path")}>{tr("Gantt")}</NavLink>
    </nav>
  )
}
